import cls from "./customInnerPage.module.scss";
import React, {FC, ReactNode} from "react";

interface IProps {
    QuantityDiscount_INTL: string;
    quantityColumnHandler: (title: string, isQuantity: boolean) => ReactNode;
    displayFilterGroup: "flex" | "none"
}

const CustomQuantityTable: FC<IProps> = ({
                                             QuantityDiscount_INTL,
                                             quantityColumnHandler,
                                             displayFilterGroup
                                         }) => {
    return (
        <ul style={{maxWidth: "100%", display: displayFilterGroup}} className={cls["product__meta"]}>
            <li style={{maxWidth: "100%"}} className={cls["product__meta-availability"]}>
                <span className={cls["quantity_table_title"]}>
                    {QuantityDiscount_INTL}
                </span>
                <div className={cls["quantity_table_main"]}>
                    {quantityColumnHandler("Quantity", true)}
                    {quantityColumnHandler("Price", false)}
                </div>
            </li>
        </ul>
    )
}

export default CustomQuantityTable;
